/**
 * Query keys for the My Election dashboard.
 *
 * Geography and register are keyed by `constituencyId` ALONE — not by election,
 * not by party. Two elections in one constituency share the cache entry, and
 * switching party never refetches a ward list that cannot have changed. That is
 * the whole reason the dashboard resolves `constituencyId` before anything else.
 *
 * Coverage keys carry election + party because the assignment ledger is seeded
 * per (election, party).
 */
export const myElectionKeys = {
	all: ['my-election'] as const,

	geography: (constituencyId: number) => [...myElectionKeys.all, 'geography', constituencyId] as const,
	lgas: (constituencyId: number) => [...myElectionKeys.geography(constituencyId), 'lgas'] as const,
	wards: (constituencyId: number) => [...myElectionKeys.geography(constituencyId), 'wards'] as const,
	puCount: (constituencyId: number) => [...myElectionKeys.geography(constituencyId), 'pu-count'] as const,

	register: (constituencyId: number) => [...myElectionKeys.all, 'register', constituencyId] as const,

	coverageRoster: (electionId: number, resultType: string) =>
		[...myElectionKeys.all, 'coverage-roster', electionId, resultType] as const,
	assignmentStats: (electionId: number, partyId: number, resultSource: string) =>
		[...myElectionKeys.all, 'assignment-stats', electionId, partyId, resultSource] as const,
};

/** Above this many polling units we do not attempt a browser-side register total. */
export const REGISTER_FETCH_CAP = 20_000;
